import { render } from "./WallAlertSilenceTab.vue?vue&type=template&id=c8b7abea&scoped=true"
import script from "./WallAlertSilenceTab.vue?vue&type=script&lang=js"
export * from "./WallAlertSilenceTab.vue?vue&type=script&lang=js"

import "./WallAlertSilenceTab.vue?vue&type=style&index=0&id=c8b7abea&scoped=true&lang=css"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b7abea"]])

export default __exports__